<template>
    <div>

        <div class="loginCont" v-if="activeLoginStyle">

            <!--密码登录-->
            <div class="loginForm">
                <div class="iptStyle1">
                    <input type="text" ref="idCardOrPhoneNumberRef" placeholder="请输入身份证号或手机号" maxlength="18"
                        @blur="checkoutIdCardOrPhoneNum" v-model="idCardOrPhoneNumber" />
                    <p class="hasError" v-show="isShowIdCardOrPhoneNumFlag">请输入正确的身份证号或手机号</p>
                </div>
                <div class="iptStyle1">
                    <input type="password" autocomplete="new-password" ref="pwdRef" placeholder="请输入密码/初始密码为身份证后6位"
                        @blur="checkoutPassword" v-model="password" />
                    <p class="hasError" v-show="isShowPwdFlag">请输入正确的密码</p>
                </div>
                <!-- <div class="iptStyle1">
                    <div class="iptYzm">
                        <input type="text" placeholder="请输入验证码" maxlength="6"/>
                        <img class="yzmImg" src="../../assets/images/captcha.png"/>
                    </div>
                </div> -->
                <div class="agreement">
                    <el-checkbox v-model="agreementChecked1"></el-checkbox>
                    <span @click='agreementFn'>个人信息及隐私保护政策</span>
                </div>
                <div class="friendFeatures">
                    <div class="fl" @click="showYzmPop('yzm')">验证码登录</div>
                    <div class="fr" @click="forgetPwdPop()">忘记密码？</div>
                </div>
                <el-button type="primary" class="loginBtn" :loading="loginLoading" @click="gotoLogin()">登录</el-button>
                <img class="loginHead" src="../../assets/images/normalLoginHead.png" />
            </div>
        </div>

        <!--验证码登录-->
        <div class="loginCont" v-else>
            <div class="loginForm">
                <div class="iptStyle1">
                    <input type="text" placeholder="请输入您的手机号" maxlength="11" v-model="phoneNumber" ref="phoneNumRef"
                        @blur="checkoutPhone" />
                    <p class="hasError" v-show="isShowPhoneNumFlag">请输入正确的手机号</p>
                </div>

                <div class="iptStyle1">
                    <div class="iptYzm">
                        <input type="text" placeholder="请输入验证码" maxlength="6" v-model="yzmNumber" ref="yzmRef" />

                        <el-button type="primary" @click='getYzmEvent' :loading='loginCodeLoading' class="getYzmBtn">
                            {{loginCodeText}}</el-button>

                        <p class="hasError" v-show="yzmNumberFlag">请输入验证码</p>
                    </div>
                </div>
                <div class="agreement">
                    <el-checkbox v-model="agreementChecked2"></el-checkbox>
                    <span @click="agreementFn">个人信息及隐私保护政策</span>
                </div>

                <div class="friendFeatures yzmLoginFriendFeatures">
                    <div class="yamLoignStyle fl" @click="showYzmPop('pwd')">密码登录</div>

                    <div class="fr" @click="forgetPwdPop()">忘记密码？</div>
                </div>
                <el-button type="primary" class="loginBtn" :loading="loginCodeBtnLoading" @click="gotoLogin()">登录
                </el-button>
                <img class="loginHead" src="../../assets/images/normalLoginHead.png" />
            </div>

        </div>

        <!--忘记密码-->
        <div class="forgetPwdCont" v-if="forgetPwdPopFlage">
            <div class="layerCover"></div>

            <div class="forgetPwdBox">
                <p class="forgetPwdTitle">忘记密码</p>

                <div class="loginCont">
                    <div class="loginForm forgetPwdForm">
                        <el-form :model="formValue" ref="formValue" :rules="rules" label-width="100px" class="">

                            <el-form-item prop="newPwd">
                                <el-input type="password" v-model="formValue.newPwd" placeholder="请输入新密码"></el-input>
                            </el-form-item>

                            <el-form-item prop="confirmNewPwd">
                                <el-input type="password" v-model="formValue.confirmNewPwd" placeholder="请确认新密码">
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="idCard">
                                <el-input v-model="formValue.idCard" placeholder="请输入身份证号"></el-input>
                            </el-form-item>

                            <el-form-item prop="phone">
                                <el-input v-model="formValue.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                            </el-form-item>

                            <div class="iptStyle1">
                                <div class="iptYzm">
                                    <el-form-item prop="forgetPwdYzm">
                                        <el-input v-model="formValue.forgetPwdYzm" maxlength="6" placeholder="请输入验证码">
                                        </el-input>
                                    </el-form-item>
                                    <el-button type="primary" @click='forgetGetCode' :loading='forgetCodeLoading'
                                        class="getYzmBtn">{{forgetCodeText}}</el-button>

                                </div>
                            </div>
                            <div>

                                <div class="loginBtn" @click="submitForm">登录</div>
                                <div class="escLoginBtn" @click="escLoginBtnEvent">取消</div>
                            </div>
                        </el-form>

                        <img class="loginHead" src="../../assets/images/normalLoginHead.png" />
                    </div>

                </div>
            </div>

        </div>

        <el-dialog title='' center class="agreementContent" :visible.sync="agreeIsShow" width="50%"
            >
            <div class="pop" v-html='content' v-loading='agreeLoading'>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import customValidate from '../../assets/js/customValidate.js';
export default {
    props: {
        loginStyle: {
            type: Boolean,
            default: true
        },
        focus: {
            type: Boolean,
        }
    },
    data () {
        return {
            loginLoading: false,
            loginCodeBtnLoading: false,

            activeLoginStyle: this.loginStyle,
            forgetPwdPopFlage: false,
            isShowIdCardOrPhoneNumFlag: false,
            isShowPwdFlag: false,
            isShowPhoneNumFlag: false,
            yzmNumberFlag: false,
            idCardOrPhoneNumber: '',
            password: '',
            phoneNumber: '',
            yzmNumber: '',
            //忘记密码数据
            formValue: {

            },
            rules: {
                newPwd: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
                ],
                confirmNewPwd: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { validator: customValidate.idCard, trigger: 'blur' },
                ],
                phone: [
                    { required: true, validator: customValidate.checkPhone, trigger: 'blur' },
                ],
                forgetPwdYzm: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
            },

            //忘记密码获取验证码按钮
            forgetCodeText: '获取验证码',
            forgetCodeLoading: false,

            //手机号登录获取验证码按钮
            loginCodeText: '获取验证码',
            loginCodeLoading: false,

            agreementChecked1: true,
            agreementChecked2: true,
            agreeIsShow: false,
            agreeLoading:false,
            content:''
        }
    },
    watch: {
        'idCardOrPhoneNumber': {
            handler: function (val, oldVal) {
                this.checkoutIdCardOrPhoneNum(val)
            },
            deep: true
        },

        'password': {
            handler: function (val, oldVal) {
                this.checkoutPassword();
            },
            deep: true
        },

        'phoneNumber': {
            handler: function (val, oldVal) {
                this.checkoutPhone();
            },
            deep: true
        },
        'yzmNumber': {
            handler: function (val, oldVal) {
                this.checkoutYzmNumber();
            },
            deep: true
        },
        focus () {
            if (this.focus) {
                this.$refs.idCardOrPhoneNumberRef.focus();
            }
        }

    },
    methods: {
        /**
         * 用户协议
         */
        agreementFn () {
            this.agreeIsShow = true;
            if( !this.content ){
                this.agreeLoading = true;
            }
            this.$store.dispatch('agreement', {}).then((res) => {
                if (res.code) {
                    this.content = res.data.agreement;
                }
                // this.loading = false;
                this.agreeLoading = false;
            }).catch(error => {
                console.error('错误信息：', error);
                // this.loading = false;
                this.agreeLoading = false;
            })
        },
        /**
         * 忘记密码获取验证码
         */
        forgetGetCode () {
            let params = {
                phone: this.formValue.phone
            }

            if (!params.phone) {
                this.$message({
                    type: 'error',
                    message: '请输入手机号'
                });
                return false;
            } else if (!/^1[3-9]\d{9}$/.test(params.phone)) {
                this.$message({
                    type: 'error',
                    message: '手机号格式不正确'
                });
                return false;
            }

            if (this.forgetCodeText != '获取验证码') {
                return false;
            }

            this.forgetCodeLoading = true;
            this.$store.dispatch('vcode', params).then((res) => {

                if (res.code == 200) {
                    let time = 60;
                    let timer = setInterval(() => {
                        --time;
                        this.forgetCodeText = time + 's'
                        if (time <= 0) {
                            this.forgetCodeText = '获取验证码';
                            clearInterval(timer);
                        }
                    }, 1000)
                }
                this.forgetCodeText = '60s';
                this.forgetCodeLoading = false;

            }).catch(error => {
                this.forgetCodeLoading = false;
                console.log('catch====', error)
            })
        },
        showYzmPop (styleFlag) {
            this.isShowIdCardOrPhoneNumFlag = false
            this.phoneNumber = ''
            this.yzmNumber = ''
            this.idCardOrPhoneNumber = ''
            this.password = ''
            this.isShowPwdFlag = false
            this.isShowPhoneNumFlag = false
            this.yzmNumberFlag = false

            switch (styleFlag) {
                case 'yzm':
                    this.activeLoginStyle = false

                    break;
                case 'pwd':
                    this.activeLoginStyle = true
                    break;
                default:
                //this.activeLoginStyle = true
            }

        },

        forgetPwdPop () {
            this.forgetPwdPopFlage = true
        },
        escLoginBtnEvent () {
            this.forgetPwdPopFlage = false
        },

        gotoLogin () {

            if (this.$refs.idCardOrPhoneNumberRef) {
                if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCardOrPhoneNumber) || /^1\d{10}$/.test(this.idCardOrPhoneNumber)) {
                    this.isShowIdCardOrPhoneNumFlag = false
                } else {
                    this.isShowIdCardOrPhoneNumFlag = true
                    return false
                }
            }


            if (this.$refs.pwdRef) {

                if (this.password.length == 0) {
                    this.isShowPwdFlag = true
                    return false
                } else {
                    this.isShowPwdFlag = false
                }
            }

            //上线需要打开注释，勿删
            if (this.$refs.phoneNumRef) {
                if (/^1\d{10}$/.test(this.phoneNumber)) {
                    this.isShowPhoneNumFlag = false
                } else {
                    this.isShowPhoneNumFlag = true
                    return false
                }
            }

            if (this.$refs.yzmRef) {
                if (this.yzmNumber.length == 0) {
                    this.yzmNumberFlag = true
                    return false
                } else {
                    this.yzmNumberFlag = false
                }
            }

            let params = {}
            if (this.activeLoginStyle) {
                params = {
                    type: '1', // 1： 密码 2：短信验证码
                    // username:'152502198803121347',
                    // password:'1234567',
                    username: this.idCardOrPhoneNumber,
                    password: this.password,
                }
                if (!this.agreementChecked1) {
                    this.$message({
                        type: 'error',
                        message: '请先勾选个人信息及隐私保护政策'
                    });
                    return false;
                }
                this.loginLoading = true;

            } else {
                params = {
                    type: '2',
                    // phone: '12211112159',
                    // vcode: '0007',
                    phone: this.phoneNumber,
                    vcode: this.yzmNumber,
                }
                if (!this.agreementChecked2) {
                    this.$message({
                        type: 'error',
                        message: '请先勾选个人信息及隐私保护政策'
                    });
                    return false;
                }
                this.loginCodeBtnLoading = true;
            }

            this.$store.dispatch('login', params).then((res) => {
                if (res.code == 200) {
                    // 密码登录时检查是否使用初始密码
                    if (this.activeLoginStyle && res.data.old_password == 1) {
                        this.$alert(res.data.tips, '安全提示', {
                            confirmButtonText: '我知道了',
                            type: 'warning',
                            callback: () => {
                                this.handleLoginSuccess(res);
                            }
                        });
                    } else {
                        this.handleLoginSuccess(res);
                    }
                }

                this.loginLoading = false;
                this.loginCodeBtnLoading = false;

            }).catch(error => {
                this.loginLoading = false;
                this.loginCodeBtnLoading = false;
                console.log('catch====', error)
            })


        },
        checkoutIdCardOrPhoneNum (value) {

            if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCardOrPhoneNumber) || /^1\d{10}$/.test(this.idCardOrPhoneNumber)) {
                this.isShowIdCardOrPhoneNumFlag = false
            } else {
                this.isShowIdCardOrPhoneNumFlag = true
            }
        },
        checkoutPassword () {
            if (this.password.length == 0) {
                this.isShowPwdFlag = true
            } else {
                this.isShowPwdFlag = false

            }
        },

        checkoutPhone () {
            if (/^1\d{10}$/.test(this.phoneNumber)) {
                this.isShowPhoneNumFlag = false
            } else {
                this.isShowPhoneNumFlag = true
            }
        },

        checkoutYzmNumber () {
            if (this.yzmNumber.length == 0) {
                this.yzmNumberFlag = true
            } else {
                this.yzmNumberFlag = false
            }

        },

        /**
         * 手机号登录获取验证码
         */
        getYzmEvent () {

            if (/^1\d{10}$/.test(this.phoneNumber)) {
                this.isShowPhoneNumFlag = false
            } else {
                this.isShowPhoneNumFlag = true
            }

            let params = {
                phone: this.phoneNumber,
            }

            if (this.loginCodeText != '获取验证码') {
                return false;
            }

            this.loginCodeLoading = true;
            this.$store.dispatch('vcode', params).then((res) => {
                if (res.code == 200) {
                    // this.$router.push('/myInfo')
                    let time = 60;
                    let timer = setInterval(() => {
                        --time;
                        this.loginCodeText = time + 's'
                        if (time <= 0) {
                            this.loginCodeText = '获取验证码';
                            clearInterval(timer);
                        }
                    }, 1000)
                }
                this.loginCodeText = '60s'
                this.loginCodeLoading = false;
            }).catch(error => {
                this.loginCodeLoading = false;
                console.log('catch====', error)
            })


        },

        /**
         * 处理登录成功后的逻辑
         */
        handleLoginSuccess (res) {
            if (res.data.face_init == 0) {
                localStorage.setItem('token', res.data.token);
                this.$router.push('/faceCollection');
            } else {
                localStorage.setItem('isLogin', true);
                localStorage.setItem('token', res.data.token);
                this.$store.commit('setLogin', true);
                this.$router.push('/studentsNote');
            }
        },

        /**
         * 忘记密码
         */
        submitForm () {
            this.$refs['formValue'].validate((valid) => {
                if (valid) {
                    let params = {
                        password: this.formValue.newPwd,
                        confirm_password: this.formValue.confirmNewPwd,
                        phone: this.formValue.phone,
                        vcode: this.formValue.forgetPwdYzm,
                        idcard: this.formValue.idCard,
                    }
                    this.$store.dispatch('forget', params).then((res) => {
                        if (res.code == 200) {
                            // this.$router.push('/myInfo')
                            this.$message('修改成功');
                            this.forgetPwdPopFlage = false;
                        }
                    }).catch(error => {
                        console.log('catch====', error)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },








    }
}
</script>

<style scoped>
.loginCont {
    margin-left: 2px;
    height: 238px;
    background: rgba(252, 248, 241, 1);
    box-shadow: 0.5px 1px 2px 0.5px rgba(106, 106, 106, 0.5);
    border-radius: 4px;
    position: relative;
    top: -1px;
    right: 1px;
}

.loginForm {
    padding: 20px 15px;
    position: relative;
}

.loginHead {
    position: absolute;
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 180px;
    top: -42px;
    left: 50%;
    transform: translateX(-50%);
}

input {
    padding: 11px 12px;
    border: none;
    outline: none;
    border-radius: 4px;
    border: 1px solid rgba(0, 116, 255, 1);
}
.iptStyle1 {
    margin-bottom: 20px;
    position: relative;
}

.iptStyle1 .hasError {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
}

.iptStyle1 input {
    width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    color: #999;
}

.iptYzm {
    position: relative;
}

.yzmImg,
.getYzmBtn {
    display: block;
    width: 80px;
    height: 38px;
    line-height: 38px;
    position: absolute !important;
    right: 0;
    top: 1px;
    /* transform: translateY(-50%); */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    cursor: pointer;
    border-left: 1px solid rgba(0, 116, 255, 1);
    background: #eef7ff !important;
    padding: 0;
    border-top: 0;
    border-bottom: 0;
}
.getYzmBtn {
    color: #0074ff !important;
    line-height: 38px;
    font-size: 12px;
    text-align: center;
}

.friendFeatures {
    overflow: hidden;
    /* margin-top: 35px; */
}

.yzmLoginFriendFeatures {
    /* margin-top: 35px; */
}
.friendFeatures > div {
    color: #0074ff;
    font-size: 12px;
    cursor: pointer;
}
.escLoginBtn,
.loginBtn {
    width: 100%;
    text-align: center;
    color: #fff;
    height: 42px;
    line-height: 42px;
    border-radius: 4px;
    margin-top: 5px;
    letter-spacing: 2px;
    cursor: pointer;
    padding: 0;
}

.loginBtn {
    background-image: -webkit-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -o-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -ms-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: linear-gradient(left, #4bb7fc, #0173ff);
}

.escLoginBtn {
    color: #0074ff;
    border: 1px solid #0074ff;
    border-image: -webkit-linear-gradient(#7db6fa #0074ff #7db6fa) 30 30;
    border-image: -moz-linear-gradient(#7db6fa #0074ff #7db6fa) 30 30;
    border-image: linear-gradient(#7db6fa #0074ff #7db6fa) 30 30;
}

.layerCover {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
}

.forgetPwdBox {
    padding: 30px 100px;
    background: #fff;
    border-radius: 4px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
}

.forgetPwdTitle {
    color: #0074ff;
    font-size: 16px;
}

.forgetPwdForm {
    margin-top: 30px;
    width: 302px;
}

.forgetPwdBox .loginCont {
    height: auto;
}
</style>

<style>
.forgetPwdForm .el-form-item__content {
    margin-left: 0 !important;
}

.forgetPwdForm .el-form-item__content input {
    border: 1px solid #0074ff;
    color: #999 !important;
}

.forgetPwdForm .el-form-item.is-error input {
    border: 1px solid #0074ff;
}

.loginCont .agreement {
    /* width: 100%; */
    color: #0074ff;
    font-size: 12px;
    /* text-align: right; */
}
.loginCont .agreement span {
    cursor: pointer;
}
.loginCont .agreement .el-checkbox__label {
    font-size: 12px;
    font-weight: normal;
}
.agreementContent .el-dialog__body{
    max-height:60vh;
    overflow-y: auto;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login.vue